import { BaseEdge, type EdgeProps } from "@xyflow/react";
import { ruleGraphFlowEdgePath } from "./ruleGraphFlowEdgePath";

/**
 * A flow edge between pipeline cards: a cubic curve with horizontal tangents
 * at both handles. Shared tail steps (the platform exclusions card, the
 * output) sit vertically centered across the rule rows, so several rows fan
 * into one card through the same 28px gap; the curves converge tangentially
 * at the target instead of stacking square brackets on top of each other.
 */
export const RuleGraphFlowEdgeLine = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}: EdgeProps) => (
  <BaseEdge
    id={id}
    markerEnd={markerEnd}
    path={ruleGraphFlowEdgePath({ sourceX, sourceY, targetX, targetY })}
    style={style}
  />
);
